module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "svi-overall--dataset-cover.e182e670.png";